module.exports = __webpack_public_path__ + "static/media/money-bag.cf0c2d2e.png";